import assolementApi from '@/api/assolement.api'

const getDefaultState = () => {
  return {
    assolement: [],
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    assolement (state) {
      return state.assolement
    },
  },

  mutations: {
    UPDATE_ASSOLEMENT (state, assolement) {
      state.assolement = assolement
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getAssolement ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return assolementApi.getAssolement(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_ASSOLEMENT', response)
          return response
        })
    },
    reset ({ commit }) {
      commit('RESET')
    },
  }
}

export default module
